export const BITMOVIN_UI_PLAYER_VERSION = 'v20250827163114'
